import React from 'react'

/**
 * SFCC-11543: Hardcoded label for the registration Terms of Use / Privacy Notice
 * acknowledgement on the create-account drawer.
 *
 * Previously this legally-required text was authored as a Builder symbol
 * (account-form-labels -> registration.termsAndConditions). In production that
 * symbol gated its text block behind an in-symbol `show` binding
 * (`state.sitePreferences.results[0].data.showTermsAndConditions`) fed by a
 * nested `httpRequests.sitePreferences` call. That binding failed to resolve at
 * runtime, so the create-account checkbox shipped with no legal text on FSA +
 * HSA. Rendering this hardcoded label removes the dependency on that fragile
 * content path and guarantees the wording always appears.
 *
 * Wording + links mirror SFRA org_hec (registration.properties +
 * registerFormFields.isml) and the Builder symbol's own copy: the "Terms of Use"
 * and "Privacy Notice" links point at the terms-and-conditions / privacy-policy
 * content pages (site-relative, so they resolve per host), opened in a new tab.
 */
export const defaultTermsAndConditionsLabel = (
    <span>
        I&apos;ve read, understand and agree to the{' '}
        <a href="/terms-and-conditions.html" target="_blank" rel="noreferrer" className="underline">
            Terms of Use
        </a>{' '}
        and{' '}
        <a href="/privacy-policy.html" target="_blank" rel="noreferrer" className="underline">
            Privacy Notice
        </a>
        .
    </span>
)
